import React            from 'react'
import PropTypes        from 'prop-types'

import { AdminPage }    from 'alto-react-components/lib/components'
import KreditRepository from 'alto-react-kredit/lib/models'

import ClientTable      from './client_table'
import ClientForm       from './client_form'
import EditUserModal    from './edit_user_modal'

export default class ClientManagement extends AdminPage
  @contextTypes = { backend: PropTypes.object }

  tableComponent: ClientTable
  formComponent:  ClientForm

  constructor: (props, context) ->
    super(props, context)

    @state.showEditUserForm = false

  relation: ->
    @__relation ?= KreditRepository.forBackend(@context.backend).clients

  additionalTableProps: ->
    onEditUser: @showEditUserForm

  showEditUserForm: (id) =>
    @setState(showEditUserForm: true,  editedRecordID: id)

  hideEditUserForm: =>
    @setState(showEditUserForm: false, editedRecordID: null)

  additionalRender: ->
    if @state.showEditUserForm
      client = @state.records.find(@state.editedRecordID)

      <EditUserModal client={client} onHide={@hideEditUserForm} />
